import { DataGrid, type DataGridProps, mergeSx } from '@shared/components';

import { columns, type LOSQuestionRow } from './columns';

export type LOSQuestionsDataGridProps = Omit<DataGridProps<LOSQuestionRow>, 'columns'>;

export default function LOSQuestionsDataGrid(props: Readonly<LOSQuestionsDataGridProps>) {
  const { sx, ...restProps } = props;

  return (
    <DataGrid
      {...restProps}
      columns={columns}
      disableColumnMenu
      disableRowSelectionOnClick
      rowHeight={48}
      sx={mergeSx(
        (theme) => ({
          '--DataGrid-overlayHeight': '352px',
          border: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.background.paper,
          '.MuiDataGrid-cell': {
            p: theme.spacing(3),
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '.MuiDataGrid-columnHeaders': {
            backgroundColor: theme.palette.grey[100],
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '.MuiDataGrid-columnHeader': {
            p: theme.spacing(2.5, 3),
          },
          '> .MuiBox-root': {
            p: theme.spacing(3, 4),
            '& .MuiToolbar-root': {
              minHeight: 'unset',
              height: 'unset',
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                m: 0,
              },
              '& .MuiTablePagination-actions': {
                ml: theme.spacing(1),
                '> button': {
                  p: theme.spacing(1),
                },
              },
            },
          },
        }),
        sx,
      )}
    />
  );
}
